import { render, staticRenderFns } from "./CommunityPosts.html?vue&type=template&id=67230aa1&external"
import script from "./CommunityPosts.js?vue&type=script&lang=js&external"
export * from "./CommunityPosts.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports